import React, { useEffect } from "react";
import OnChargeIcon from "assets/svgIcons/AdminDashboard/OnChargeIcon";
import NotOnCharge from "assets/svgIcons/AdminDashboard/NotOnCharge";
import OutOfServiceIcon from "assets/svgIcons/AdminDashboard/OutOfServiceIcon";
import CarIcon from "assets/svgIcons/CarIcon";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "../../../../redux/reduxToolkitServices/_commonServices/commonServices";
import { siteId } from "redux/reduxToolkitServices/_commonApiCalls/api";
import moment from "moment";
import { useHookstate } from "@hookstate/core";
import {
  LIST_BY_GLOBAL_STATES,
  MAP_GLOBAL_STATES,
  SIDENAV_GLOBAL_STATE,
  SITEID_GLOBAL_STATE,
} from "globalStore/globalStore";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { API_STATUSES } from "redux/_helpers/statuses";
const CarSelection = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const dispatch = useDispatch();
  const {
    getCarSelectionState,
    getCarSelectionStatus,
    siteSettingsData,
    getDashboardFeatureSetStatus,
  } = useSelector((state) => state?.commonReducers) || [];
  const { subNavDataState, sideDrawerActiveTabState } =
    useHookstate(SIDENAV_GLOBAL_STATE);
  const { mapSideNavTabState } = useHookstate(MAP_GLOBAL_STATES);
  const {
    listBy,
    showFilterServices,
    showFilterNotCommunicating,
    showFilterbattry,
  } = useHookstate(LIST_BY_GLOBAL_STATES);

  useEffect(() => {
    if (
      getDashboardFeatureSetStatus === API_STATUSES.SUCCESS &&
      siteId.get() !== null &&
      siteSettingsData &&
      Object.keys(siteSettingsData).length > 0
    ) {
      const lastQueryDate = moment(new Date())
        .utc()
        .utcOffset(-siteSettingsData?.TimeZoneOffset)
        .format("YYYY-MM-DD");

      dispatch(
        COMMON_SERVICES.getCarSelectionServices(
          siteId.get(),
          lastQueryDate,
          localStorage.getItem("dashCourseId")
        )
      );
    }
  }, [
    getDashboardFeatureSetStatus,
    siteId.get(),
    localStorage.getItem("dashCourseId"),
    siteSettingsData,
  ]);

  const redirectFunction = (redirectKey) => {
    navigate("/fleet");
    subNavDataState.set("FLEET");
    sideDrawerActiveTabState.set(2);
    mapSideNavTabState.set("Cars");
    localStorage.setItem("mapSideNavTabState", "Cars");

    if (redirectKey === "charging") {
      listBy.set("CHARGING");
      showFilterServices.set(true);
      showFilterNotCommunicating.set(true);
      showFilterbattry.set(true);
    } else {
      listBy.set("NONE");
      showFilterServices.set(true);
      showFilterNotCommunicating.set(false);
      showFilterbattry.set(false);
      localStorage.setItem("ShowCOS", true);
      localStorage.setItem("showCNC", false);
      localStorage.setItem("showCarCharger", false);
      localStorage.setItem("MemberCache", false);
    }
  };

  return (
    <>
      <div className="header">
        <CarIcon color="#666" />
        <p className="blue-border">{t("Car_Selection")}</p>
      </div>
      <div className="box-body action-zone-infraction">
        <div onClick={() => redirectFunction("charging")}>
          <p>
            <OnChargeIcon />
            {t("On_charge")}
          </p>
          <h2 className="see-green">
            {getCarSelectionState && getCarSelectionState[0]?.Oncharge}
          </h2>
        </div>
        <div onClick={() => redirectFunction("charging")}>
          <p>
            <NotOnCharge />
            {t("NOT_on_charge")}
          </p>
          <h2 className="red">
            {getCarSelectionState && getCarSelectionState[0]?.NotonCharge}
          </h2>
        </div>
        <div onClick={() => redirectFunction("outOfService")}>
          <p>
            <OutOfServiceIcon />
            {t("Out_of_service")}
          </p>
          <h2 className="red">
            {getCarSelectionState && getCarSelectionState[0]?.OutofService}
          </h2>
        </div>
      </div>
    </>
  );
};

export default CarSelection;
